import { render, staticRenderFns } from "./foody_export.vue?vue&type=template&id=300472ce&scoped=true&"
import script from "./foody_export.vue?vue&type=script&lang=js&"
export * from "./foody_export.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300472ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('300472ce')) {
      api.createRecord('300472ce', component.options)
    } else {
      api.reload('300472ce', component.options)
    }
    module.hot.accept("./foody_export.vue?vue&type=template&id=300472ce&scoped=true&", function () {
      api.rerender('300472ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/foody/foody_export.vue"
export default component.exports